// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);
    var PlugUtils = PLUG.import("Utils");
	var ProductCard = PLUG.import("ProductCard");

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

    /* Boost-250763 */
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
		// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
        
		// Check on sale
		var onSale = this.data.compare_at_price_min > this.data.price_min;
		// Format price
		var price = Utils.formatMoney(this.data.price_min);
		var compareAtPrice = '';
		if (this.data && this.data.compare_at_price_min) {
			compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
			if (Settings.getSettingValue('search.removePriceDecimal')) {
				price = Utils.removeDecimal(price);
				compareAtPrice = Utils.removeDecimal(compareAtPrice);
			}
		}
        var variant = this.data.variants[0];
        var variantPrice = variant.price;
		var variantCompareAtPrice = variant.compare_at_price;
		if (PLUG.selectedCurrency) {
			if (variant[`price_${PLUG.selectedCurrency.toLowerCase()}`]) {
				this.data.price_min = variant[`price_${PLUG.selectedCurrency.toLowerCase()}`];
			}
			if (variant[`compare_at_price_${PLUG.selectedCurrency.toLowerCase()}`]) {
				this.data.compare_at_price_min = variant[`compare_at_price_${PLUG.selectedCurrency.toLowerCase()}`];
			}
		}
        var price = ProductCard.computePrice(variantPrice * 100, this.data.tags);
        var compareAtPrice = ProductCard.computeCompareAtPrice(variantPrice * 100, variantCompareAtPrice * 100, this.data.tags);
		
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
			} else {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
			}
		}
		return result
			.replace(/{{regularPrice}}/g, ProductCard.buildPriceEle(price, compareAtPrice, true))
			.replace(/{{compareAtPrice}}/g, ProductCard.buildCompareAtPriceEle(price, compareAtPrice, true));
	}

    Utils.reBuildUrlBaseOnLocale = function(url) {
    	// remove http or https
    	url = url.replace('https://', '').replace('http://', '');
    
    	// Rebuild URL based on Shopify's routes object
    	var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
    	if (hasShopifyRoutes) {
    		return Shopify.routes.root.replace(/\/$/, '') + url;
    		// Rebuild URL based on published locales
    	} else {
    		var currentLocale = Settings.getSettingValue('general.current_locale');
    		var publishedLocales = Settings.getSettingValue('general.published_locales');
    		var publishedLocaleKeys = Object.keys(publishedLocales);
    		var currentLocaleIndex = publishedLocaleKeys.indexOf(currentLocale);
    
    		// If the locale isnt in the published list, or is default locale, return the normal url
    		if (currentLocaleIndex < 0 || publishedLocales[currentLocale] == true) return url;
    
    		var urlArr = url.split('/');
    		if (urlArr.length > 1 && publishedLocaleKeys.length && currentLocale.length) {
    			var isUrlHasLocaleString = publishedLocaleKeys.indexOf(urlArr[1]) > -1;
    			if (isUrlHasLocaleString) {
    				urlArr[1] = currentLocale;
    			} else {
    				urlArr.splice(1, 0, currentLocale);
    			}
    		}
    		return urlArr.join('/');
    	}
    }

    Utils.buildProductItemUrl = function(data, hasCollection) {
    	// Get url information
    	var params = Utils.getWindowLocation().search.substring(1);
    	var pathname = window.location.pathname;
    	var elements = pathname.split('/');
    
    	// Check if has locale
    	var localeURLPart = "";
    	var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
    	if (hasShopifyRoutes) {
    		localeURLPart = Shopify.routes.root.replace(/\/$/, '');
    	} else if (elements.indexOf(boostPFSAppConfig.general.current_locale) > -1) {
    		localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
    	}

        // Get product handle
    	var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;
    	var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : Settings.getSettingValue('general.addCollectionToProductUrl');
    	if (hasCollection) {
    		// Homepage or Search page
    		if (pathname == '/' || Utils.isSearchPage() || Utils.isVendorPage() || Utils.isTypePage()) {
    			var preHandle = localeURLPart + '/collections/all/products/';
    			return preHandle + handle;
    
    		// Tag Page
    		} else if (Utils.isTagPage()) {
    			var preHandle = localeURLPart + '/collections/';
    			var collectionHandleIndex = elements.indexOf("collections") + 1
    			if (elements.length >= 4) return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
    			return '/collections/all/products/' + handle;
    		} else {
    			// Google cache URL
    			// An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
    			if (params.indexOf('cache:') > -1) {
    				var collectionHandle = 'all';
    				var temp = params.split('&')[0].split('?')[0].split('collections/');
    				if (temp.length > 1) {
    					if (temp[1].indexOf('/') > -1) {
    						collectionHandle = temp[1].split('/')[0];
    					}
    					else {
    						collectionHandle = temp[1];
    					}
    				}
    				collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
                    return '/collections/' + collectionHandle + '/products/' + handle;
    			}
              	var collectionHandleIndex = elements.indexOf("collections") + 1
    			var preHandle = localeURLPart + '/collections/';
    			if (typeof elements[2] !== 'undefined') {
    				return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
    			}
    			return window.location.pathname + '/products/' + handle;
    		}
    	}
    	return localeURLPart + '/products/' + handle;
    };
    /* Boost-250763 */
})();